if($('#copyLink').length){
    var app = new Vue({
        el: '#copyLink',
        data: {
            link: null
        },
        methods: {
            copyLink(){
                var theURL = new URL(window.location.href)
                theURL.searchParams.set('referrer', '');
                this.link = theURL.toString()

                this.$nextTick(() => {
                    var copyText = document.getElementById("referall-link");
                    copyText.select();
                    copyText.setSelectionRange(0, 99999);
                    document.execCommand("copy");
                    copyText.blur();

                    this.$toasted.success('Link copied to clipboard');
                });
            },
        }
    });
}